import PropTypes from 'prop-types';
import React from 'react';
import { ModelYear } from '@sm360/widget-commons-vehicle';

import FeatureIcon from 'build-and-quote/components/ModelTrims/ModelTrimFeatures/FeatureIcon.jsx';

import 'build-and-quote/components/Summary/components/VehicleCharacteristics/components/FeatureBlock.scss';

const FeatureBlock = ({ features, packageName }) => {
    return (
        <div className="feature-block">
            <p className="sr-text is-bold is-small feature-block-title">{packageName}</p>
            <ul className="features-list">
                {features.map((featureIcon) => (
                    <FeatureIcon
                        key={`${featureIcon.get('code')}|${featureIcon.getIn(['iconObject', 'code'])}`}
                        code={featureIcon.get('code')}
                        description={featureIcon.getIn(['iconObject', 'typeDescription'])}
                    />
                ))}
            </ul>
        </div>
    );
};

FeatureBlock.propTypes = {
    features: PropTypes.arrayOf(PropTypes.instanceOf(ModelYear.FeatureIcon)).isRequired,
    packageName: PropTypes.string.isRequired,
};

FeatureBlock.displayName = 'FeatureBlock';

export default FeatureBlock;
